import { useEffect, useRef, useState } from 'react';

const TARGETING_COOKIE_ARRAY = ['C0002', 'C0004'];

const stringToArray = (str: string) => (str ? str.slice(1, -1).split(',') : []);

const isAcceptedAllCookies = (cookieList: string[]) =>
    cookieList.some((value) => TARGETING_COOKIE_ARRAY.includes(value));

type UseOneTrustInitParams = { onConsent?: () => void };

type UseOneTrustResult = {
    isBannerClosed: boolean;
};

export const useOneTrust = ({ onConsent }: UseOneTrustInitParams): UseOneTrustResult => {
    const consentCalledRef = useRef(false);
    const [isBannerClosed, setIsBannerClosed] = useState(() => Boolean(window.OneTrust?.IsAlertBoxClosed?.()));

    useEffect(() => {
        const interval = setInterval(() => {
            const oneTrust = window.OneTrust;

            if (!oneTrust) return;

            const closed = Boolean(oneTrust.IsAlertBoxClosed?.());
            setIsBannerClosed(closed);

            const cookieList = closed ? stringToArray(window.OptanonActiveGroups) : [];
            const isAllowed = isAcceptedAllCookies(cookieList);

            if (isAllowed && !consentCalledRef.current) {
                consentCalledRef.current = true;
                onConsent?.();
            }

            if (!closed && oneTrust.OnConsentChanged) {
                oneTrust.OnConsentChanged(({ detail }: { detail: string[] }) => {
                    setIsBannerClosed(true);

                    const isAllowed = isAcceptedAllCookies(detail);

                    if (isAllowed && !consentCalledRef.current) {
                        consentCalledRef.current = true;
                        onConsent?.();
                    }
                });
            }

            clearInterval(interval);
        }, 200);

        return () => clearInterval(interval);
    }, [onConsent]);

    return { isBannerClosed };
};
